import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import React__default from 'react';
import cns from '../../node_modules/classnames/index.js';
import Validation, { getValidation } from '../Validation/index.js';
import { formatValue, format, alignment, parse } from '../Utils/numeriHelper.js';
import { getProp, setProp } from '../Utils/formHelpers.js';
import { getTitle, Presentation, getRandomId } from '../Utils/baseComponentHelper.js';
import Restriction from '../Restriction/Restriction.js';
import Log from '../../utils/log.js';
import useActivation from '../Hooks/useActivation.js';
import EllipsisText from '../EllipsisText/EllipsisText.js';
import useValidations from '../Hooks/useValidations.js';
import ValidationViewer from '../Validation/ValidationViewer.js';
import { namecase } from '../Utils/stringHelper.js';
import { isNotNumber } from '../../utils/js.js';

const KeyCodes = {
    Period: 190,
    DecimalPoint: 110,
    Comma: 188,
};
class Input extends React__default.Component {
    constructor(props) {
        super(props);
        this.getTitle = () => {
            const { title, validations } = this.props;
            return getTitle(title, validations);
        };
        this.isValid = () => getValidation(this.valida()).valid;
        this.isZero = (val) => val === 0;
        this.getValueFromValue = (setState = true) => {
            const { zeroValid, defaultValue, value: valueP } = this.props;
            // eslint-disable-next-line react/destructuring-assignment
            const value = this.state ? this.state.value : valueP;
            if (value || value === '' || (zeroValid && this.isZero(value))) {
                if (setState)
                    this.setState({ value });
                return value;
            }
            let valueS = null;
            if (this.state) {
                const { value: valueState } = this.state;
                valueS = valueState;
            }
            if (valueS === null) {
                if (defaultValue || defaultValue === '' || (zeroValid && this.isZero(defaultValue))) {
                    if (setState)
                        this.setState({ value: defaultValue });
                    return defaultValue;
                }
                if (setState)
                    this.setState({ value: undefined });
                return undefined;
            }
            return valueS;
        };
        this.getValue = (setState = true) => {
            const { stato, name } = this.props;
            if (stato && name) {
                return getProp(name, stato);
            }
            return this.getValueFromValue(setState);
        };
        this.reset = () => {
            this.setState({ dirty: false });
        };
        this.clear = () => {
            this.setState({
                value: '',
            });
        };
        this.valida = () => {
            const { format: formatP, validations, zeroValid, } = this.props;
            if (validations === undefined) {
                return { valid: true };
            }
            let value = this.getValue(false);
            if (formatP && value !== '' && (!value || zeroValid)) {
                value = this.formatta(+value, true);
            }
            return Validation.validateAll(validations, value);
        };
        this.notifica = (event) => {
            const { format: formatP, name, onChange, nameCase, upperCase, readOnly, stato, onFormChange, } = this.props;
            let value = null;
            let targetValue = event.target.value === undefined || event.target.value === null ? '' : event.target.value;
            targetValue = new Presentation({ readOnly }).parse(targetValue);
            // nel caso di restrizioni verifico che non siano passati caratteri
            // particolari (ad esempio da un incolla)
            const { restrictions } = this.props;
            if (restrictions) {
                const isNumber = typeof targetValue === 'number';
                targetValue = `${targetValue}`.split('').filter((char) => Restriction.isValid({ keyCode: char.charCodeAt(0) }, // per mantenere compatibilità
                restrictions)).join('');
                if (isNumber)
                    targetValue = Number(targetValue);
            }
            // procedo con la formattazione
            if (formatP) {
                value = parse(targetValue);
                if (this.formattedField.current && this.formattedField.current.value === '') {
                    value = null;
                }
            }
            else if (nameCase) {
                // nel caso di nameCase ed uppercase formatto la stringa, e ripristino il cursore
                const hasSelection = !!this.unformattedField.current.selectionStart;
                const start = hasSelection ? this.unformattedField.current.selectionStart : 0;
                const end = hasSelection ? this.unformattedField.current.selectionEnd : 0;
                value = namecase(targetValue);
                this.unformattedField.current.value = value;
                if (hasSelection) {
                    this.unformattedField.current.setSelectionRange(start, end);
                }
            }
            else if (upperCase) {
                const hasSelection = !!this.unformattedField.current.selectionStart;
                const start = hasSelection ? this.unformattedField.current.selectionStart : 0;
                const end = hasSelection ? this.unformattedField.current.selectionEnd : 0;
                value = targetValue.toUpperCase();
                this.unformattedField.current.value = value;
                if (hasSelection) {
                    this.unformattedField.current.setSelectionRange(start, end);
                }
            }
            else {
                value = targetValue;
            }
            if (onFormChange && name) {
                const obj = {};
                setProp(name, value, obj, stato);
                onFormChange(obj, name, value);
            }
            this.setState({ value });
            onChange === null || onChange === void 0 ? void 0 : onChange(event, value);
        };
        this.formatta = (value, keepZero) => {
            const { precisione, format: formatP } = this.props;
            if (!formatP)
                return value;
            if ((value === 0 && !keepZero) || isNotNumber(value)) {
                return '';
            }
            return formatValue(value, formatP, precisione);
        };
        this.focus = () => {
            var _a, _b;
            (_a = this.formattedField.current) === null || _a === void 0 ? void 0 : _a.focus();
            (_b = this.unformattedField.current) === null || _b === void 0 ? void 0 : _b.focus();
        };
        this.focused = () => (this.formattedField && document.activeElement === this.formattedField.current)
            || (this.unformattedField && document.activeElement === this.unformattedField.current);
        this.onBlur = (event) => {
            const { format: formatP, disabled: disabledProp, readOnly: readOnlyProp, onBlur, } = this.props;
            const { active } = useActivation(disabledProp, readOnlyProp); // NOSONAR
            const newEvent = event;
            if (active) {
                newEvent.target.value = this.valueChanged(formatP, newEvent);
            }
            const { dirty } = this.state;
            if (!dirty) {
                this.setState({ dirty: true });
            }
            onBlur === null || onBlur === void 0 ? void 0 : onBlur(newEvent);
        };
        this.onKeyPress = (event) => {
            const { restrictions, onKeyPress } = this.props;
            if (restrictions) {
                if (!Restriction.isValid(event, restrictions)) {
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
            onKeyPress === null || onKeyPress === void 0 ? void 0 : onKeyPress(event);
        };
        this.onKeyDown = (event) => {
            const { format: formatP, precisione, onKeyDown } = this.props;
            if (formatP) {
                if (formatP === 'number' && !precisione
                    && (event.which === KeyCodes.DecimalPoint || event.which === KeyCodes.Comma)) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                if ((event.which === KeyCodes.Comma || event.which === KeyCodes.DecimalPoint || event.which === KeyCodes.Period)) {
                    if (this.formattedField.current.value.indexOf(',') !== -1) {
                        event.preventDefault();
                    }
                    else {
                        event.preventDefault();
                        this.formattedField.current.value = `${this.formattedField.current.value},`;
                    }
                }
            }
            onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
        };
        const { stato, name, value } = this.props;
        if (stato && name && value) {
            Log.warn(`Input[${name}]: se impostato lo state e il name non deve essere impostato il value`);
        }
        this.state = {
            dirty: false,
            value: this.getValue(false),
        };
        this.uniqueid = getRandomId();
        this.formattedField = React__default.createRef();
        this.unformattedField = React__default.createRef();
    }
    componentDidMount() {
        const { name, addToForm, zeroValid, } = this.props;
        if (addToForm && name) {
            addToForm(name, this.valida(), this.reset);
        }
        const value = this.getValue();
        if (zeroValid && this.isZero(value) && format) {
            this.aggiornaValoreInput(this.formatta(value, zeroValid));
        }
    }
    UNSAFE_componentWillReceiveProps({ value, readOnly: readOnlyProp, disabled: disabledProp }) {
        const { value: valueP, readOnly: readOnlyP, zeroValid } = this.props;
        const { readOnly } = useActivation(disabledProp, readOnlyProp); // NOSONAR
        if ((value || value === '' || (!zeroValid && this.isZero(value))) && valueP !== value) {
            this.setState({ value });
        }
        if (readOnly !== readOnlyP) {
            this.aggiornaValoreInput(this.formatta(value, zeroValid));
        }
    }
    componentWillUnmount() {
        const { name, removeFromForm } = this.props;
        if (removeFromForm && name) {
            removeFromForm(name);
        }
    }
    getAlignment() {
        const { align, format: formatP } = this.props;
        return alignment(formatP, align);
    }
    aggiornaValoreInput(value) {
        const { readOnly: readOnlyProp, disabled: disabledProp } = this.props;
        const { readOnly } = useActivation(disabledProp, readOnlyProp); // NOSONAR
        if (this.formattedField.current) {
            this.formattedField.current.value = new Presentation({ readOnly }).format(value);
        }
    }
    valueChanged(formatP, newEvent) {
        const { zeroValid } = this.props;
        let inputValue = newEvent.target.value;
        const val = newEvent.target.value;
        if (formatP) {
            let valore = this.formatta(parse(newEvent.target.value), zeroValid);
            inputValue = parse(valore);
            if (newEvent.target.value === '') {
                inputValue = null;
                valore = '';
            }
            setTimeout(() => {
                this.aggiornaValoreInput(val === '' ? '' : valore);
                if (zeroValid && val === '') { // hp cancellato, non mi deve riproposse 0
                    this.notifica({ target: { value: '' } });
                }
                else {
                    this.notifica({ target: { value: parse(valore) } });
                }
            }, 0);
        }
        return inputValue;
    }
    renderInput(value) {
        const _a = this.props, { actions, addToForm, className, format: formatP, isValid, nameCase, onBlur, onChange, onFormChange, onKeyDown, precisione, removeFromForm, resetta, stato, type, upperCase, validare, validations, value: rValue, title, zeroValid, name, defaultValue, restrictions, onKeyPress, readOnly: readOnlyProp, disabled: disabledProp, align, ellipsis, titleLines, placeholder, icon } = _a, others = __rest(_a, ["actions", "addToForm", "className", "format", "isValid", "nameCase", "onBlur", "onChange", "onFormChange", "onKeyDown", "precisione", "removeFromForm", "resetta", "stato", "type", "upperCase", "validare", "validations", "value", "title", "zeroValid", "name", "defaultValue", "restrictions", "onKeyPress", "readOnly", "disabled", "align", "ellipsis", "titleLines", "placeholder", "icon"]);
        let newValue = value;
        const { disabled, readOnly } = useActivation(disabledProp, readOnlyProp); // NOSONAR
        const inputClass = cns('input__input', 'validationViewer__target', `input__input--${this.getAlignment()}`, {
            'input__input--readonly': readOnly,
        });
        if (readOnly) {
            let formattedValue;
            if (formatP) {
                if (zeroValid && this.isZero(newValue)) {
                    formattedValue = this.formatta(+newValue, zeroValid);
                }
                else if (zeroValid && !newValue) {
                    formattedValue = '';
                }
                else {
                    formattedValue = this.formatta(+newValue, zeroValid);
                }
            }
            else {
                formattedValue = newValue;
            }
            const t = new Presentation({ readOnly }).format(formattedValue);
            return (jsx("span", Object.assign({ className: inputClass }, others, { children: jsxs(EllipsisText, Object.assign({}, ellipsis, { children: [t, ' '] })) })));
        }
        if (formatP) {
            if (!this.focused()) {
                if (this.formattedField.current) {
                    if (parse(newValue) !== parse(this.formattedField.current.value)) {
                        setTimeout(() => {
                            this.aggiornaValoreInput(this.formatta(+newValue, zeroValid));
                        }, 0);
                    }
                    else if (zeroValid && this.isZero(newValue)) {
                        setTimeout(() => {
                            this.aggiornaValoreInput(this.formatta(+newValue, zeroValid));
                        }, 0);
                    }
                    else if (zeroValid && !newValue) {
                        setTimeout(() => {
                            this.aggiornaValoreInput('');
                        }, 0);
                    }
                    else if (!newValue && !zeroValid) {
                        setTimeout(() => {
                            this.aggiornaValoreInput(newValue || '');
                        }, 0);
                    }
                }
                else {
                    newValue = !!format && (!zeroValid || newValue !== '') ? this.formatta(+newValue, zeroValid) : newValue;
                }
            }
            return (jsx("input", Object.assign({ id: this.uniqueid, autoComplete: `input-${this.uniqueid}`, className: inputClass, defaultValue: new Presentation({ readOnly }).format(newValue), onBlur: this.onBlur, onChange: this.notifica, onKeyDown: this.onKeyDown, onKeyPress: this.onKeyPress, ref: this.formattedField, type: type || 'text', "data-origin": name, readOnly: readOnly, disabled: disabled, placeholder: placeholder }, others)));
        }
        if (newValue && nameCase) {
            newValue = namecase(newValue);
        }
        else if (newValue && upperCase) {
            newValue = newValue.toUpperCase();
        }
        return (jsx("input", Object.assign({ id: this.uniqueid, autoComplete: `input-${this.uniqueid}`, className: inputClass, onBlur: this.onBlur, onChange: this.notifica, onKeyDown: this.onKeyDown, onKeyPress: this.onKeyPress, ref: this.unformattedField, type: type || 'text', value: new Presentation({ readOnly }).format(newValue), "data-origin": name, readOnly: readOnly, disabled: disabled, placeholder: placeholder }, others)));
    }
    render() {
        const { isValid, validare, name, className, icon, title, titleLines, actions, readOnly: readOnlyProp, disabled: disabledProp, } = this.props;
        const { dirty } = this.state;
        const { readOnly } = useActivation(disabledProp, readOnlyProp); // NOSONAR
        const validazione = getValidation(this.valida());
        if (isValid != null && name) {
            isValid(name, validazione.valid, validazione.messages || []);
        }
        const contesto = this.getValue(false);
        const { hasError, hasWarning } = useValidations(validare, dirty, validazione); // NOSONAR
        const classes = cns('input', {
            'input--empty': contesto === undefined || contesto === null || contesto === '',
            'input--has-validation': hasError || hasWarning,
            'input--invalid': hasError,
            'input--valid': !hasError,
            'input--right-with-icon': icon && this.getAlignment() === 'right',
        }, `input--titleLines${titleLines}`, className);
        const inputTitleClass = cns('input__title', { 'input__title--readOnly': readOnly });
        const label = name || title;
        return (jsxs("div", { className: classes, children: [jsxs("div", { className: "input__container", children: [this.renderInput(contesto), label && jsx("label", { htmlFor: this.uniqueid, className: "input__label", children: label }), title && jsx("span", { className: inputTitleClass, children: this.getTitle() }), jsx("span", { className: "input__bar" }), jsx(ValidationViewer, { hasError: hasError, hasWarning: hasWarning, validazione: validazione, className: icon ? 'input__validation--before-icon' : undefined }), icon && React__default.createElement(icon, { className: 'input__icon' })] }), !readOnly && actions && jsx("div", { className: "input__actions", children: actions })] }));
    }
}
Input.defaultProps = {
    actions: null,
    className: null,
    format: null,
    name: null,
    nameCase: false,
    upperCase: false,
    onBlur: null,
    onChange: null,
    onKeyDown: null,
    precisione: null,
    title: null,
    type: null,
    zeroValid: false,
    validations: null,
    restrictions: null,
    value: null,
    onKeyPress: null,
    onKeyUp: null,
    readOnly: false,
    disabled: false,
    align: null,
    ellipsis: {
        left: false,
        top: true,
        disabled: false,
    },
    titleLines: 1,
    placeholder: undefined,
    icon: undefined,
    defaultValue: undefined,
};

export { Input as default };
